export const D2P_MARKETING_PARAM_COOKIE = 'plan_code';
export const LOAD_D2P_DATA = 'LOAD_D2P_DATA';
